import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requiredRoles = [], redirectTo = '/sign-in' }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Show loading indicator or skeleton screen
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page with the return URL
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // Check if user has required role - case insensitive comparison
  const userRole = user?.role?.toLowerCase();
  const requiredRolesLower = requiredRoles.map(role => role.toLowerCase());
  
  if (requiredRoles.length > 0 && !requiredRolesLower.includes(userRole)) {
    console.log("Access denied - User role:", userRole, "Required roles:", requiredRoles);
    // User doesn't have required role, redirect to appropriate dashboard or access denied
    if (userRole === 'admin' || userRole === 'superuser') {
      return <Navigate to="/admin-dashboard" replace />;
    } else if (userRole === 'user') {
      return <Navigate to="/user-dashboard" replace />;
    }
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export const PublicRoute = ({ children, redirectTo = '/' }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    // Show loading indicator or skeleton screen
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    // If user is authenticated, redirect away from public routes
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
